// tslint:disable:max-line-length
import * as React from 'react';

export const IconDomRf = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" fill="white" />
      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <circle cx="12" cy="12" r="12" fill="#FED141" />
      </mask>
      <g mask="url(#mask0)">
        <circle cx="12" cy="12" r="12" fill="#FED141" />
        <mask id="mask1" mask-type="alpha" maskUnits="userSpaceOnUse" x="2" y="5" width="20" height="19">
          <path d="M21.4375 5.125H2.5625V24H21.4375V5.125Z" fill="white" />
        </mask>
        <g mask="url(#mask1)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.12626 16.9218C4.08375 19.638 2.5625 23.3606 2.5625 28.0895C2.5625 32.8185 9.27361 33.5485 22.6958 30.2793C20.6592 20.85 17.7721 16.1354 14.0345 16.1354C10.2968 16.1354 7.9941 16.3975 7.12626 16.9218Z"
            fill="white"
            stroke="#1C1B28"
            strokeWidth="0.94375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.67732 5.85074C5.74612 5.6912 5.93122 5.61764 6.09076 5.68644L8.67072 6.79868C9.59637 6.23008 10.6871 5.90197 11.8549 5.90197C13.0168 5.90197 14.1023 6.22674 15.0249 6.78999L17.5842 5.68644C17.7438 5.61764 17.9289 5.6912 17.9977 5.85074C18.0246 5.91318 18.0306 5.98265 18.0147 6.04876L17.2604 9.19152C17.6847 10.0158 17.9241 10.9499 17.9241 11.9397C17.9241 15.2742 15.2068 17.9774 11.8549 17.9774C8.503 17.9774 5.78573 15.2742 5.78573 11.9397C5.78573 10.9683 6.01632 10.0505 6.426 9.23753L5.66031 6.04876C5.64443 5.98265 5.6504 5.91318 5.67732 5.85074Z"
            fill="white"
            stroke="#1C1B28"
            strokeWidth="0.94375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.7612 13.2215L20.3952 12.1974"
            stroke="#1C1B28"
            strokeWidth="0.94375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.4304 14.8771L20.3883 16.2016"
            stroke="#1C1B28"
            strokeWidth="0.94375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.59841 13.0802L3.15896 11.6501"
            stroke="#1C1B28"
            strokeWidth="0.94375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.56885 14.7214L4.08325 16.2184"
            stroke="#1C1B28"
            strokeWidth="0.94375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0203 14.13L12.7207 13.1979H11.3198L12.0203 14.13Z"
            fill="#FED141"
            stroke="#1C1B28"
            strokeWidth="1.25833"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.30041 11.2652C9.75191 11.2652 10.1179 10.9001 10.1179 10.4496C10.1179 9.99918 9.75191 9.63403 9.30041 9.63403C8.84892 9.63403 8.48291 9.99918 8.48291 10.4496C8.48291 10.9001 8.84892 11.2652 9.30041 11.2652Z"
            fill="#1C1B28"
          />
          <path
            d="M14.2054 11.2652C14.6569 11.2652 15.0229 10.9001 15.0229 10.4496C15.0229 9.99918 14.6569 9.63403 14.2054 9.63403C13.7539 9.63403 13.3879 9.99918 13.3879 10.4496C13.3879 10.9001 13.7539 11.2652 14.2054 11.2652Z"
            fill="#1C1B28"
          />
        </g>
      </g>
    </svg>
  );
};
